import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const liveAuctionApi = createApi({
  reducerPath: reducerPaths.liveAuctionApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getLiveAuctionVehicles: builder.query({
      query: ({ endpoint, method, payload }) => ({
        url: `/myGarage/Seller/LiveInAuction`,
        method: method || "GET",
        params: payload,
        // body: payload
      }),
    }),
    getBidHistory: builder.query({
      query: ({ vehicleId }) => {
        return {
          url: `/bidhistory/${vehicleId}`,
        };
      },
    }),
    getAuctionHistorySeller: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/seller/previousBidHistory/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    cancelAuction: builder.mutation({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/cancel-auction/${Vehicle_Id}`,
          method: "POST"
        }
      }
    }),
    getVehicleMakes: builder.query({
      query: ({ endpoint, method }) => {
        return {
          url: endpoint,
          method: "GET",
        };
      },
    }),
    getVehicleModels: builder.mutation({
      query: ({ endpoint, method, payload }) => {
        return {
          url: endpoint,
          method: method || "POST",
          body: payload,
        };
      },
    }),
    getTimeoutDetails: builder.query({
      query: ({ vehicleId }) => {
        return {
          url: `/timeoutdetails/${vehicleId}`
        }
      }
    }),
    setDealerBidPrice: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `/dealer/dealerbidprice`,
          body: payload
        }
      }
    }),
  }),
});

export const {
  useSetDealerBidPriceMutation,
  useGetLiveAuctionVehiclesQuery,
  useGetBidHistoryQuery,
  useGetVehicleMakesQuery,
  useGetVehicleModelsMutation,
  useCancelAuctionMutation,
  useGetTimeoutDetailsQuery
} = liveAuctionApi;

export const {
  useLazyGetBidHistoryQuery,
  useLazyGetLiveAuctionVehiclesQuery,
  useLazyGetVehicleMakesQuery,
  useLazyGetTimeoutDetailsQuery,
  useLazyGetAuctionHistorySellerQuery,
} = liveAuctionApi;
